import { render, staticRenderFns } from "./Further-correction.vue?vue&type=template&id=76cba605&"
import script from "./Further-correction.vue?vue&type=script&lang=js&"
export * from "./Further-correction.vue?vue&type=script&lang=js&"
import style0 from "./Further-correction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports